// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.input-filter-form-clicker {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 25px 20px;
  margin: 20px auto; 
  gap: 20px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 8px; 
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
    
  .clicker-report-field {
    display: flex;
    flex-direction: column;
    width: 25%
  }
    
    .clicker-report-field label {
      font-weight: bold;
      margin-bottom: 8px;
      text-align: left;
    }
    
    .clicker-report-field input {
      padding: 10px 5px;
      font-size: 16px;
      border: 1px solid #f2f2f2;
    }
    
    .clicker-form-actions {
      display: flex;
      gap: 10px;
      align-items: center;
      padding: 15px 0 0;
    }
    
    .clicker-form-actions .btn {
      padding: 8px 16px;
      font-size: 16px;
      border: none;
      border-radius: 4px;
      cursor: pointer;
    }
    
    .clicker-form-actions .submit-btn {
      background-color: #44a67e;
      border-color: #44a67e;
    }
    
    .clicker-form-actions .submit-btn:hover {
      background-color: #44a67e;
      border-color: #44a67e;
      box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
    }

    .clicker-form-actions .download-btn {
      background: #373435;
      color: #ffcc29;
    }
    
    .clicker-form-actions .download-btn:hover {
      background: #373435;
      color: #ffcc29;
      box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
    }

  /* Clicker Report Table Style */
  .clicker-report-table-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    padding: 25px 20px;
    margin: 20px auto; 
    max-width: 90%; 
    gap: 20px;
    background-color: #f9f9f9; 
    border: 1px solid #ddd;
    border-radius: 8px; 
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    overflow-x: auto;
    white-space: none;
}

.clicker-report-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

.clicker-report-table th,
.clicker-report-table td {
  padding: 12px 15px;
  border: 1px solid #ddd;
  font-size: 14px;
}

.clicker-report-table th {
  background-color: #f4f4f4;
  color: #373435;
  font-weight: 600;
  text-transform: uppercase;
  text-align: left;
}

.clicker-report-table tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

.clicker-report-table tbody tr:hover {
  background-color:  rgba(255, 204, 41, 0.2);
}

.clicker-report-table td {
  color: #373435;
}

.clicker-report-table tbody tr:last-child td {
  border-bottom: 2px solid #ffcc29;
}

/* Expand Button */
.clicker-expand-btn {
  background: #373435;
  color: #ffcc29;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  border-radius: 4px;
  font-size: 16px;
}

.clicker-expand-btn:hover {
  background: #ffcc29;
  color: #373435;
}

/* Expanded Row */
.clicker-expanded-row {
  background-color: #eef7ff;
}

.clicker-expanded-content {
  padding: 10px;
}

/* ==========Message Note Style=========  */
.clicker-report-field .input-alert-combine {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.clicker-report-field small {
  color: #373435;
  font-size: 12px;
  text-align: start;
}

.clicker-pagination-buttons {
  display: flex;
  justify-content: end;
  gap: 10px;
  margin-bottom: 50px;
}

.clicker-pagination-buttons button {
  min-width: 30px;
  height: 30px;
  border: 1px solid #ddd;
  background: #fff;
  border-radius: 6px;
  cursor: pointer;
}

.clicker-pagination-buttons button:hover:not(:disabled) {
  background: #f5f5f5;
}

.clicker-pagination-buttons button.active {
  background: #ffcc29;
  color: #000;
  border-color: #ffcc29;
  font-weight: 600;
}

.clicker-pagination-buttons button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.ellipsis {
  padding: 0 6px;
}

.clicker-date-note {
  color: #d32f2f;
  font-size: 14px;
  font-weight: 500;
}

.clicker-date-note strong {
  font-weight: 700;
}

/* Loader Style */
.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #373435;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loader-overlay p {
  margin-top: 10px;
  font-size: 1rem;
  color: #333;
}

.clicker-whole-wrap {
  margin: 0 40px;
}


@media (max-width: 850px) {
    .clicker-whole-wrap .input-filter-form-clicker {
        flex-direction: column;
    }
}  `, "",{"version":3,"sources":["webpack://./src/components/ClickerReport/ClickerReport.css"],"names":[],"mappings":";;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;AAC1C;;EAEE;IACE,aAAa;IACb,sBAAsB;IACtB;EACF;;IAEE;MACE,iBAAiB;MACjB,kBAAkB;MAClB,gBAAgB;IAClB;;IAEA;MACE,iBAAiB;MACjB,eAAe;MACf,yBAAyB;IAC3B;;IAEA;MACE,aAAa;MACb,SAAS;MACT,mBAAmB;MACnB,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;MACjB,eAAe;MACf,YAAY;MACZ,kBAAkB;MAClB,eAAe;IACjB;;IAEA;MACE,yBAAyB;MACzB,qBAAqB;IACvB;;IAEA;MACE,yBAAyB;MACzB,qBAAqB;MACrB,qFAAqF;IACvF;;IAEA;MACE,mBAAmB;MACnB,cAAc;IAChB;;IAEA;MACE,mBAAmB;MACnB,cAAc;MACd,qFAAqF;IACvF;;EAEF,+BAA+B;EAC/B;IACE,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,SAAS;IACT,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;IACxC,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0CAA0C;EAC1C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;;AAGA;IACI;QACI,sBAAsB;IAC1B;AACJ","sourcesContent":["\r\n\r\n.input-filter-form-clicker {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 25px 20px;\r\n  margin: 20px auto; \r\n  gap: 20px;\r\n  background-color: #fff;\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px; \r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n    \r\n  .clicker-report-field {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 25%\r\n  }\r\n    \r\n    .clicker-report-field label {\r\n      font-weight: bold;\r\n      margin-bottom: 8px;\r\n      text-align: left;\r\n    }\r\n    \r\n    .clicker-report-field input {\r\n      padding: 10px 5px;\r\n      font-size: 16px;\r\n      border: 1px solid #f2f2f2;\r\n    }\r\n    \r\n    .clicker-form-actions {\r\n      display: flex;\r\n      gap: 10px;\r\n      align-items: center;\r\n      padding: 15px 0 0;\r\n    }\r\n    \r\n    .clicker-form-actions .btn {\r\n      padding: 8px 16px;\r\n      font-size: 16px;\r\n      border: none;\r\n      border-radius: 4px;\r\n      cursor: pointer;\r\n    }\r\n    \r\n    .clicker-form-actions .submit-btn {\r\n      background-color: #44a67e;\r\n      border-color: #44a67e;\r\n    }\r\n    \r\n    .clicker-form-actions .submit-btn:hover {\r\n      background-color: #44a67e;\r\n      border-color: #44a67e;\r\n      box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;\r\n    }\r\n\r\n    .clicker-form-actions .download-btn {\r\n      background: #373435;\r\n      color: #ffcc29;\r\n    }\r\n    \r\n    .clicker-form-actions .download-btn:hover {\r\n      background: #373435;\r\n      color: #ffcc29;\r\n      box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;\r\n    }\r\n\r\n  /* Clicker Report Table Style */\r\n  .clicker-report-table-container {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 25px 20px;\r\n    margin: 20px auto; \r\n    max-width: 90%; \r\n    gap: 20px;\r\n    background-color: #f9f9f9; \r\n    border: 1px solid #ddd;\r\n    border-radius: 8px; \r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n    overflow-x: auto;\r\n    white-space: none;\r\n}\r\n\r\n.clicker-report-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  text-align: left;\r\n}\r\n\r\n.clicker-report-table th,\r\n.clicker-report-table td {\r\n  padding: 12px 15px;\r\n  border: 1px solid #ddd;\r\n  font-size: 14px;\r\n}\r\n\r\n.clicker-report-table th {\r\n  background-color: #f4f4f4;\r\n  color: #373435;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  text-align: left;\r\n}\r\n\r\n.clicker-report-table tbody tr:nth-child(even) {\r\n  background-color: #f9f9f9;\r\n}\r\n\r\n.clicker-report-table tbody tr:hover {\r\n  background-color:  rgba(255, 204, 41, 0.2);\r\n}\r\n\r\n.clicker-report-table td {\r\n  color: #373435;\r\n}\r\n\r\n.clicker-report-table tbody tr:last-child td {\r\n  border-bottom: 2px solid #ffcc29;\r\n}\r\n\r\n/* Expand Button */\r\n.clicker-expand-btn {\r\n  background: #373435;\r\n  color: #ffcc29;\r\n  border: none;\r\n  padding: 5px 10px;\r\n  cursor: pointer;\r\n  border-radius: 4px;\r\n  font-size: 16px;\r\n}\r\n\r\n.clicker-expand-btn:hover {\r\n  background: #ffcc29;\r\n  color: #373435;\r\n}\r\n\r\n/* Expanded Row */\r\n.clicker-expanded-row {\r\n  background-color: #eef7ff;\r\n}\r\n\r\n.clicker-expanded-content {\r\n  padding: 10px;\r\n}\r\n\r\n/* ==========Message Note Style=========  */\r\n.clicker-report-field .input-alert-combine {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n}\r\n\r\n.clicker-report-field small {\r\n  color: #373435;\r\n  font-size: 12px;\r\n  text-align: start;\r\n}\r\n\r\n.clicker-pagination-buttons {\r\n  display: flex;\r\n  justify-content: end;\r\n  gap: 10px;\r\n  margin-bottom: 50px;\r\n}\r\n\r\n.clicker-pagination-buttons button {\r\n  min-width: 30px;\r\n  height: 30px;\r\n  border: 1px solid #ddd;\r\n  background: #fff;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n}\r\n\r\n.clicker-pagination-buttons button:hover:not(:disabled) {\r\n  background: #f5f5f5;\r\n}\r\n\r\n.clicker-pagination-buttons button.active {\r\n  background: #ffcc29;\r\n  color: #000;\r\n  border-color: #ffcc29;\r\n  font-weight: 600;\r\n}\r\n\r\n.clicker-pagination-buttons button:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.ellipsis {\r\n  padding: 0 6px;\r\n}\r\n\r\n.clicker-date-note {\r\n  color: #d32f2f;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n}\r\n\r\n.clicker-date-note strong {\r\n  font-weight: 700;\r\n}\r\n\r\n/* Loader Style */\r\n.loader-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(255, 255, 255, 0.8);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 9999;\r\n}\r\n\r\n.loader {\r\n  border: 4px solid #f3f3f3;\r\n  border-top: 4px solid #373435;\r\n  border-radius: 50%;\r\n  width: 40px;\r\n  height: 40px;\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n.loader-overlay p {\r\n  margin-top: 10px;\r\n  font-size: 1rem;\r\n  color: #333;\r\n}\r\n\r\n.clicker-whole-wrap {\r\n  margin: 0 40px;\r\n}\r\n\r\n\r\n@media (max-width: 850px) {\r\n    .clicker-whole-wrap .input-filter-form-clicker {\r\n        flex-direction: column;\r\n    }\r\n}  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
